import type { SeloPremiadoItem, NovoSeloForm } from "../models/seloPremiadoFornecedorModel"

export enum SeloPremiadoFornecedorActionsTypes {
    CARREGAR = "CARREGAR",
    SET_BUSCA = "SET_BUSCA",
    ATUALIZAR_CAMPO_NOVO = "ATUALIZAR_CAMPO_NOVO",
    RESETAR_FORM = "RESETAR_FORM",
}

type CarregarAction = {
    type: SeloPremiadoFornecedorActionsTypes.CARREGAR
    payload: SeloPremiadoItem[]
}

type SetBuscaAction = {
    type: SeloPremiadoFornecedorActionsTypes.SET_BUSCA
    payload: string
}

type AtualizarCampoNovoAction = {
    type: SeloPremiadoFornecedorActionsTypes.ATUALIZAR_CAMPO_NOVO
    payload: { campo: keyof NovoSeloForm; valor: string }
}

type ResetarFormAction = {
    type: SeloPremiadoFornecedorActionsTypes.RESETAR_FORM
}

export type SeloPremiadoFornecedorAction =
    | CarregarAction
    | SetBuscaAction
    | AtualizarCampoNovoAction
    | ResetarFormAction
